export const approvalRouter = {
  list: {
    name: 'list-approval',
  },
  info: {
    name: 'info-approval',
  },
}

export default [
  {
    path: '/approval',
    name: 'approvals',
    component: () => import('@/view/pages/approvals/Approval.vue'),
    children: [
      {
        path: '/',
        name: approvalRouter.list.name,
        component: () => import('@/view/pages/approvals/list/List.vue'),
        meta: {
          title: 'Danh sách phiếu yêu cầu duyệt chi - ClickBuy',
        },
      },
      {
        path: ':id',
        name: approvalRouter.info.name,
        component: () => import('@/view/pages/approvals/info/Info.vue'),
        meta: {
          title: 'Chi tiết phiếu yêu cầu duyệt chi - ClickBuy',
        },
        props: true,
      },
    ],
  },
]
